import { CountrySelect, CurrencySelect, TimezoneSelect } from '@/components/selects/MasterDataSelects';
import type { MasterOption } from '@/api/masterData.api';
import { countryLabelFromOptions } from '@/utils/masterOptionLabels';
import { cn } from '@/utils/cn';

export interface MasterLocaleValue {
  countryCode: string;
  currencyCode: string;
  timezone: string;
}

export function countryLabel(countries: MasterOption[], code: string): string {
  return countryLabelFromOptions(countries, code);
}

interface MasterLocaleSelectsProps {
  value: Partial<MasterLocaleValue>;
  onChange: (patch: Partial<MasterLocaleValue>) => void;
  showCountry?: boolean;
  showCurrency?: boolean;
  showTimezone?: boolean;
  countryRequired?: boolean;
  currencyRequired?: boolean;
  timezoneRequired?: boolean;
  disabled?: boolean;
  className?: string;
}

/** Country, currency, and timezone searchable dropdowns backed by `/v1/master-data`. */
export function MasterLocaleSelects({
  value,
  onChange,
  showCountry = true,
  showCurrency = true,
  showTimezone = true,
  countryRequired,
  currencyRequired,
  timezoneRequired,
  disabled,
  className,
}: MasterLocaleSelectsProps) {
  return (
    <div className={cn('grid gap-4 sm:grid-cols-2', className)}>
      {showCountry && (
        <CountrySelect
          label={countryRequired ? 'Country *' : 'Country'}
          disabled={disabled}
          required={countryRequired}
          value={value.countryCode ?? ''}
          onChange={(v) => onChange({ countryCode: v })}
        />
      )}
      {showCurrency && (
        <CurrencySelect
          label={currencyRequired ? 'Currency *' : 'Currency'}
          disabled={disabled}
          required={currencyRequired}
          value={value.currencyCode ?? ''}
          onChange={(v) => onChange({ currencyCode: v })}
        />
      )}
      {showTimezone && (
        <TimezoneSelect
          label={timezoneRequired ? 'Timezone *' : 'Timezone'}
          disabled={disabled}
          required={timezoneRequired}
          value={value.timezone ?? ''}
          onChange={(v) => onChange({ timezone: v })}
        />
      )}
    </div>
  );
}
